import React, { useEffect, useMemo, useRef, useState } from "react";

import { Stage, Layer, Image } from "react-konva";
import { useDataset } from "../../Api/newSockets.api";
import PolygonAnnotation from "./PolygonAnnotation";
import useCheckMobileScreen from "../../hooks/useCheckScreen";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import RectangleAnnotation from "./RectangleAnnotation";
const videoSource = "./cat.jpg";

type Props = {
  activeImage: any;
  activeTool: any
  scale: number;
  stageDraggable: boolean;
  annotations: any
  setAnnotations: any
  // onAnnotationChange: any
  activeAnnotationId: any
  onActiveAnnotationIdChange: any
  onToolChange: any
};

const AnnotationImage = ({ activeImage, activeTool, annotations, setAnnotations, activeAnnotationId, onActiveAnnotationIdChange, onToolChange, scale, stageDraggable }: Props) => {

  console.log("activeImage", activeImage);


  // Annotation logic
  // const [image, setImage] = useState<any>(activeImage);
  const [canvasImage, setCanvasImage] = useState<any>();
  const imageRef = useRef(null);
  const dataRef = useRef(null);
  const [size, setSize] = useState<any>({});
  // const [annotations, setAnnotations] = useState<any>(activeImage.fileAnnotations[0]?.annotations);
  const [_activeAnnotationId, setActiveAnnotationId] = useState<any>(activeAnnotationId);
  // const [activeFlattenedPoints, setActiveFlattenedPoints] = useState([]);
  // const [activePoints, setActivePoints] = useState([]);
  const [isActivePolyComplete, setActivePolyComplete] = useState(false);
  const [drawingMode, setDrawingMode] = useState(false);

  const [position, setPosition] = useState([0, 0]);
  const [isMouseOverPoint, setMouseOverPoint] = useState(false);

  const videoElement = useMemo(() => {
    const element = new window.Image();
    element.width = activeImage?.width;
    element.height = activeImage?.height;
    element.src = activeImage
    ?.url;
    return element;
  }, [activeImage]);



  // useEffect(() => {
  //   // setImage(activeImage);
  //   // setAnnotations(activeImage.fileAnnotations[0]?.annotations);
  //   console.log("activeImage changed", activeImage)
  //   console.log("activeImage annotations", activeImage.fileAnnotations[0]?.annotations)
  //   // setActiveAnnotationId(activeImage.fileAnnotations[0]?.annotations[0]?.id);
  //   // updateAnnotation(activeImage);
  // }, [activeImage]);

  useEffect(() => {
    if(activeTool == "polygon") {
      // if(isActivePolyComplete) {
        console.log("Tool changed to polygon")
        if(annotations) {
          setAnnotations([...annotations, {id: annotations.length + 1, type: "polygon", points: [], flattenPoints: [], isPolyComplete: false} ])
          onActiveAnnotationIdChange(annotations.length + 1)
        } else {
          setAnnotations([{id: 1, type: "polygon", points: [], flattenPoints: [], isPolyComplete: false} ])
          onActiveAnnotationIdChange(1)
        }
    }
    else if (activeTool == "rectangle") {
      console.log("Tool changed to rectangle")
      if(annotations) {
        setAnnotations([...annotations, {id: annotations.length + 1, type: "rectangle", points: [], flattenPoints: [], isPolyComplete: false} ])
        onActiveAnnotationIdChange(annotations.length + 1)
      } else {
        setAnnotations([{id: 1, type: "rectangle", x: undefined, y: undefined, width: undefined, height: undefined, points: [], flattenPoints: [], isPolyComplete: false} ])
        onActiveAnnotationIdChange(1)
      }
    }
    // updateAnnotation(activeImage);
  }, [activeTool]);

  useEffect(() => {
    const onload = function () {
      setSize({
        width: videoElement.width,
        height: videoElement.height,
      });
      setCanvasImage(videoElement);
      imageRef.current = videoElement;
    };
    videoElement.addEventListener("load", onload);
    return () => {
      videoElement.removeEventListener("load", onload);
    };
  }, [videoElement]);


  const getMousePos = (stage) => {
    return [(stage.getPointerPosition().x - stage.getAbsolutePosition().x) * 1 / scale, (stage.getPointerPosition().y - stage.getAbsolutePosition().y) * 1 / scale];
  };

  //drawing begins when mousedown event fires.
  const handleMouseDown = (e) => {
      switch (activeTool) {
        case "polygon":
          handlePolygonMouseDown(e);
          break;
        case "rectangle":
          if(drawingMode) {
            handleRectangleMouseDown(e);
          }
          else {
            handleRectangleMouseDown(e);
          }
        break;
    };
  };


  const handlePolygonMouseDown = (e) => {
    if (annotations.find((ann) => ann.id == activeAnnotationId).isPolyComplete) return;
    const stage = e.target.getStage();
    const mousePos = getMousePos(stage);

    if (isMouseOverPoint && annotations.find((ann:any) => ann.id == activeAnnotationId).points.length >= 3) {
      var _annotations = annotations?.map((annotation) => {
        if (annotation.id === activeAnnotationId) {
          return { ...annotation, isPolyComplete: true };
        }
        return annotation;
      })
      // onAnnotationChange(_annotations)
      onToolChange("select");
      setAnnotations(_annotations)

    } else {
      setAnnotations(
        annotations?.map((annotation) => {
          if (annotation.id === activeAnnotationId) {
            return { ...annotation, points: [...annotation.points, mousePos], flattenedPoints: [...annotation.points, mousePos].concat(isActivePolyComplete ? [] : position).reduce((a, b) => a.concat(b), []) };
          }
          return annotation;
        })
      )
    }
  };

  const handleRectangleMouseDown = (e) => {
    if (annotations.find((ann) => ann.id == activeAnnotationId).width) return;
    const stage = e.target.getStage();
    const mousePos = getMousePos(stage);

    setDrawingMode(true)
    setAnnotations(
      annotations?.map((annotation) => {
        if (annotation.id === activeAnnotationId) {
          // return { ...annotation, points: [...annotation.points, mousePos] };
          return { ...annotation, x: mousePos[0], y: mousePos[1], points: [mousePos] };
        }
        return annotation;
      })
    )
  }
  // const handleRectangleMouseDown = (e) => {
  //   if (isActivePolyComplete) return;

  //   const stage = e.target.getStage();
  //   const mousePos = getMousePos(stage);
  //   var annotations.find((ann:any) => ann.id == activeAnnotationId)
  //   // if (isMouseOverPoint && points.length >= 3) {
  //   //   setPolyComplete(true);
  //   // } else {
  //   setActivePoints([...activePoints, mousePos]);
  //   setDrawingMode(true);
  //   // }
  // };


 
  // reverse co-ords if user drags left / up
  const reverse = (r1, r2) => {
    var r1x = r1.x, r1y = r1.y, r2x = r2.x,  r2y = r2.y, d;
    if (r1x > r2x ){
      d = Math.abs(r1x - r2x);
      r1x = r2x; r2x = r1x + d;
    }
    if (r1y > r2y ){
      d = Math.abs(r1y - r2y);
      r1y = r2y; r2y = r1y + d;
    }
      return ({x1: r1x, y1: r1y, x2: r2x, y2: r2y}); // return the corrected rect.
  }

  const handleMouseMove = (e) => {
    switch (activeTool) {
      case "polygon":
        handlePolygonMouseMove(e);
        break;
      case "rectangle":
        if(drawingMode) {
          console.log("drawingMode", drawingMode)
          handleDrawingRectangleMouseMove(e);
        }
        else {
          handleRectangleMouseMove(e);
        }
        break;
    };
  };

  const handlePolygonMouseMove = (e) => {
    const stage = e.target.getStage();
    const mousePos = getMousePos(stage);
    setPosition(mousePos);
  };

  const handleDrawingRectangleMouseMove = (e) => {
    const stage = e.target.getStage();
    const mousePos = getMousePos(stage);
    setAnnotations(
      annotations?.map((annotation) => {
        if (annotation.id === activeAnnotationId) {
          // return { ...annotation, points: [...annotation.points, mousePos] };
          return { ...annotation, width: mousePos[0] - annotation.x, height:mousePos[1] - annotation.y };
        }
        return annotation;
      })
    )
    // const recPos = reverse(activePoints[0], mousePos);
    // quick comment
    // setPosition([[recPos.x1, recPos.y1], [recPos.x2, recPos.y2]]);

  };

  const handleRectangleMouseMove = (e) => {
    const stage = e.target.getStage();
    const mousePos = getMousePos(stage);
    setPosition(mousePos);

    // setAnnotations(
    //   annotations.map((annotation) => {
    //     if (annotation.id === activeAnnotationId) {
    //       // return { ...annotation, points: [...annotation.points, mousePos] };
    //       return { ...annotation, width: mousePos[0] - annotation.x, height:mousePos[1] - annotation.y, points: [...annotation.points, mousePos], flattenedPoints: [...annotation.points, mousePos].concat(annotation.isPolyCOmplete ? [] : position).reduce((a, b) => a.concat(b), []) };
    //     }
    //     return annotation;
    //   })
    // )
    // const recPos = reverse(activePoints[0], mousePos);
    // quick comment
    // setPosition([[recPos.x1, recPos.y1], [recPos.x2, recPos.y2]]);

  };
  const handleRectangleMouseUp = (e) => {
    if (drawingMode) {
      const stage = e.target.getStage();
      const mousePos = getMousePos(stage);
      setDrawingMode(false)

      var _annotations = annotations?.map((annotation) => {
        if (annotation.id === activeAnnotationId) {
          // return { ...annotation, points: [...annotation.points, mousePos] };
          var width = mousePos[0] - annotation.x;
          var height = mousePos[1] - annotation.y;
          return { ...annotation, width: width, height: height, isPolyComplete: true, points: [[annotation.x, annotation.y], [annotation.x + width, annotation.y], [annotation.x, annotation.y + height], [annotation.x + width, annotation.y + height] ], flattenedPoints: [[annotation.x, annotation.y], [annotation.x + width, annotation.y], [annotation.x, annotation.y + height], [annotation.x + width, annotation.y + height] ].concat([]).reduce((a, b) => a.concat(b), []) };
        }
        return annotation;
      })
      setAnnotations(_annotations)
      // onAnnotationChange(_annotations)
      onToolChange("select");
    }
  }
  const handleMouseUp = (e) => {
    switch (activeTool) {
      case "polygon":
        break;
      case "rectangle":
        handleRectangleMouseUp(e);
        break;
    };
  };
  const handleMouseOverStartPoint = (e) => {
    // console.log("MouseOver: ----- isActivePolyComplete", isActivePolyComplete, "lenght:", annotations.find((ann:any) => ann.id == activeAnnotationId).points.length);
    var activeAnnotation = annotations.find((ann:any) => ann.id == activeAnnotationId)
    console.log("MouseOver: ----- isActivePolyComplete", activeAnnotation.isPolyComplete, "active ann:", activeAnnotation);
    if (activeAnnotation.isPolyComplete || activeAnnotation.length < 3) return;
    e.target.scale({ x: 3, y: 3 });
    setMouseOverPoint(true);
  };
  const handleMouseOutStartPoint = (e) => {
    e.target.scale({ x: 1, y: 1 });
    setMouseOverPoint(false);
  };
  const handlePointDragMove = (e, _annotation) => {
    setActiveAnnotationId(_annotation.id);
    switch(_annotation.type) {
      case "polygon":
        handlePolygonPointDragMove(e, _annotation);
        break;
      case "rectangle":
        handleRectanglePointDragMove(e, _annotation);
        break;
    }  
  }
  const handlePolygonPointDragMove = (e, _annotation) => {
    const stage = e.target.getStage();
    const index = e.target.index - 1;
    const pos = [e.target._lastPos.x, e.target._lastPos.y];
    if (pos[0] < 0) pos[0] = 0;
    if (pos[1] < 0) pos[1] = 0;
    if (pos[0] > stage.width()) pos[0] = stage.width();
    if (pos[1] > stage.height()) pos[1] = stage.height();
    setAnnotations(
      annotations?.map((annotation) => {
        if (annotation.id === _annotation.id) {
          return { ...annotation, points: [...annotation.points.slice(0, index), pos, ...annotation.points.slice(index + 1)], flattenedPoints: [...annotation.points.slice(0, index), pos, ...annotation.points.slice(index + 1)].concat(annotation.isPolyComplete ? [] : position).reduce((a, b) => a.concat(b), []) };
        }
        return annotation;
      })
    )
    // setActivePoints([...activePoints.slice(0, index), pos, ...activePoints.slice(index + 1)]);
  };
  const handleRectanglePointDragMove = (e, _annotation) => {
    const stage = e.target.getStage();
    const index = e.target.index - 1;
    const pos = [e.target._lastPos.x, e.target._lastPos.y];
    if (pos[0] < 0) pos[0] = 0;
    if (pos[1] < 0) pos[1] = 0;
    if (pos[0] > stage.width()) pos[0] = stage.width();
    if (pos[1] > stage.height()) pos[1] = stage.height();
    
    
    const mousePos = getMousePos(stage);
    var width = pos[0] - _annotation.x;
    var height = pos[1] - _annotation.y;
    console.log("--setting--");
    setAnnotations(

      annotations?.map((annotation) => {
        if (annotation.id === _annotation.id) {
          console.log("setting annotation: ", annotation, _annotation);
          return { ...annotation,  width: width, height: height, points: [[annotation.x, annotation.y], [annotation.x + width, annotation.y], [annotation.x, annotation.y + height], [annotation.x + width, annotation.y + height] ], flattenedPoints: [[annotation.x, annotation.y], [annotation.x + width, annotation.y], [annotation.x, annotation.y + height], [annotation.x + width, annotation.y + height] ].concat([]).reduce((a, b) => a.concat(b), [])};
        }
        return annotation;
      })
    )
    // debugger;
    // setActivePoints([...activePoints.slice(0, index), pos, ...activePoints.slice(index + 1)]);
  };
  // useEffect(() => {

  //   // setActiveFlattenedPoints(
  //   //   activePoints.concat(isActivePolyComplete ? [] : position).reduce((a, b) => a.concat(b), [])
  //   // )
  //   console.log("activeAnnotationId: ", activeAnnotationId)
  //   activeAnnotationId &&
  //   setAnnotations(
  //     annotations.map((annotation) => {
  //       console.log("annotation id: ", annotation.id, "activeAnnotationId: ", activeAnnotationId)
  //       if (annotation.id === activeAnnotationId) {
  //         return { ...annotation, flattenedPoints: annotation.points.concat(isActivePolyComplete ? [] : position).reduce((a, b) => a.concat(b), []) };
  //       }
  //       return annotation;
  //     }
  //   ))

  // }, [activeAnnotationId])

  // const undo = () => {
  //   setActivePoints(activePoints.slice(0, -1));
  //   setActivePolyComplete(false);
  // };

  const handleGroupDragEnd = (e, index, annotation) => {
    switch (annotation.type) {
      case "polygon":
        handlePolygonDragEnd(e, index, annotation);
        break;
      case "rectangle":
        handleRectangleDragEnd(e, index, annotation);
        break;
    }
  };
  const handlePolygonDragEnd = (e, index, annotation) => {
    //drag end listens other children circles' drag end event
    //...that's, why 'name' attr is added, see in polygon annotation part
    if (e.target.name() === "polygon") {
      let result = [];
      let copyPoints = [...annotations.find((ann:any) => ann.id == annotation.id).points];
      result = copyPoints.map((point) =>
        [point[0] + e.target.x(), point[1] + e.target.y()]
      );
      e.target.position({ x: 0, y: 0 }); //needs for mouse position otherwise when click undo you will see that mouse click position is not normal:)
      var _annotations = annotations?.map((annotation, i) => {
        if (i === index) {
          console.log("Have a match: ", annotation, annotation.id)
          return {
            ...annotation,
            points: result,
            flattenedPoints: result.reduce((a, b) => a.concat(b), []),
            isPolyComplete: true,
          };
        }
        return annotation;
      });
      setAnnotations(_annotations);
    }
      // onAnnotationChange(_annotations)
  }
  const handleRectangleDragEnd = (e, index, annotation) => {
    // onActiveAnnotationIdChange(annotation.id);
    //drag end listens other children circles' drag end event
    //...that's, why 'name' attr is added, see in polygon annotation part
    if (e.target.name() === "rectangle") {
      let result = [];
      let copyPoints = [...annotations.find((ann:any) => ann.id == annotation.id).points];
      result = copyPoints.map((point) =>
        [point[0] + e.target.x(), point[1] + e.target.y()]
      );
      console.log("result", result)
      e.target.position({ x: 0, y: 0 }); //needs for mouse position otherwise when click undo you will see that mouse click position is not normal:)
      var _annotations = annotations?.map((annotation, i) => {
        if (i === index) {
          var width = annotation.width;
          var height = annotation.height;
          return { ...annotation, x: result[0][0], y: result[0][1], width: width, height: height, isPolyComplete: true, points: result, flattenedPoints: result.reduce((a, b) => a.concat(b), []) };
        }
        return annotation;
      }
    );
      setAnnotations(_annotations);
    }
      // onAnnotationChange(_annotations)
  }

  // const handleRectangleMouseUp = (e) => {
  //   if (drawingMode) {
  //     const stage = e.target.getStage();
  //     const mousePos = getMousePos(stage);
  //     setDrawingMode(false)
  //     setAnnotations(
  //       annotations.map((annotation) => {
  //         if (annotation.id === activeAnnotationId) {
  //           // return { ...annotation, points: [...annotation.points, mousePos] };
  //           var width = mousePos[0] - annotation.x;
  //           var height = mousePos[1] - annotation.y;
  //           return { ...annotation, width: width, height: height, isPolyComplete: true, points: [[annotation.x, annotation.y], [annotation.x + width, annotation.y], [annotation.x, annotation.y + height], [annotation.x + width, annotation.y + height] ], flattenedPoints: [[annotation.x, annotation.y], [annotation.x + width, annotation.y], [annotation.x, annotation.y + height], [annotation.x + width, annotation.y + height] ].concat([]).reduce((a, b) => a.concat(b), []) };
  //         }
  //         return annotation;
  //       })
  //     )
  //   }
  // }
  


  const handleActiveAnnotationChange = (annotation) => {
    if (activeTool == "select") {
    console.log("handleActiveAnnotationChange: ", annotation)
    onActiveAnnotationIdChange(annotation.id);
    }
  };


  return (
    activeImage ?
    <div className={`annotation-editor`}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Stage
          width={activeImage?.width || 480}
          height={activeImage?.height || 360}
          onMouseMove={handleMouseMove}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          scaleX={scale}
          scaleY={scale}
          draggable={stageDraggable}
          // quick comment
          // onMouseUp={handleMouseUp}
        >
          <Layer>
            <Image
              ref={imageRef}
              image={canvasImage}
              x={0}
              y={0}
              width={activeImage?.width}
              height={activeImage?.height}
            />
              {
                annotations?.map((annotation, index) => {
                  // console.log("Annotation: ", annotation[index], annotation,annotation.flattenedPoints ? true : false, index )
                  switch (annotation.type) {
                    case "polygon":
                      return (
                      <PolygonAnnotation
                      id={annotation.id}
                      points={annotation.points}
                      key={index}
                      active={activeAnnotationId == annotation.id? true : false}
                      flattenedPoints={annotation.flattenedPoints}
                      handlePointDragMove={(e) => handlePointDragMove(e, annotation)}
                      handleGroupDragEnd={(e) => handleGroupDragEnd(e, index, annotation)}
                      handleMouseOverStartPoint={handleMouseOverStartPoint}
                      handleMouseOutStartPoint={handleMouseOutStartPoint}
                      handleActiveAnnotationChange={() => handleActiveAnnotationChange(annotation)}
                      isFinished={annotation.isPolyComplete}
                    />
                    )
                    case "rectangle":
                      return (
                        <RectangleAnnotation
                        id={annotation.id}
                        points={annotation.points}
                        key={index}
                        x={annotation.x}
                        y={annotation.y}
                        width={annotation.width}
                        height={annotation.height}
                        active={activeAnnotationId == annotation.id? true : false}
                        flattenedPoints={annotation.flattenedPoints}
                        handlePointDragMove={(e) => handlePointDragMove(e, annotation)}
                        handleGroupDragEnd={(e) => handleGroupDragEnd(e, index, annotation)}
                        handleMouseOverStartPoint={handleMouseOverStartPoint}
                        handleMouseOutStartPoint={handleMouseOutStartPoint}
                        handleActiveAnnotationChange={() => handleActiveAnnotationChange(annotation)}
                        isFinished={annotation.isPolyComplete}
                        
                        // handlePointDragMove={(e) => handlePointDragMove(e, annotation)}


                        />
                      )
                    }
                })
              }
          </Layer>
        </Stage>
      </div>
    </div>
    : <LoadingSpinner />
  );
};

export default AnnotationImage;
